import { api } from "@/builders/axios";

const get = function (id: number) {
  return api
    .get<{
      name: string;
      department_id: number;
    }>(`/career-path/${id}`)
    .then(({ data }) => data);
};

const put = function (id: number, data: { name: string }) {
  return api.put(`/career-path/${id}`, data);
};

const patch = function (id: number, data: { name: string }) {
  return api.patch(`/career-path/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/career-path/${id}`);
};

export const id = {
  get,
  put,
  patch,
  del,
};
